<div class="page-login" *ngIf="isOpen">
  <div class="background-page" [ngStyle]="{'background-image':'url('+backgroundImageUrl+')'}"></div>
  <div class="sides p-grid p-col-12">
    <div class="left-side p-col-12 p-lg-6">
      <div class="auth-box">
        <img class="logo" *ngIf="conferenceData?.fileAuthentication?.url"
            [src]="conferenceData?.fileAuthentication?.url" alt=""/>
        <div class="header">
          <h2 tabindex="0">{{ conferenceData?.titleAuthentication }}</h2>
          <p tabindex="0">{{ conferenceData?.subtitleAuthentication }}</p>
        </div>
        <div class="social-login">
          <button class="cidadao" (click)="signInAcessoCidadao()">
            <span style="width: 100%; justify-content: center;display: flex;align-items: center;">
              <img src="assets/images/govbrbranco.png"  />
              <img src="assets/icons/cidadao.svg" alt=""/>
              Acessar com GOV.BR ou ACESSO CIDADÃO
            </span>
          </button>
          
        </div>
        <a href="/#/how-it-works-slim" target="blank" class="how-it-works-container">Saiba como
          participar</a>
          <div class="policy-container">
            <a class="policy-link" target="blank" href="assets/docs/privacy-policy.html">Política de Privacidade</a>
          </div>
          <div class="or">
            <img class="poweredBy" src="assets/images/poweredBy.svg" alt="">
          </div>
      </div>
    </div>
    <div  *ngIf=" calendarImageUrl != '' " >
      <img class="agenda-mobile" src="{{calendarImageUrl}}" alt=""/>
    </div>
    <div class="right-side p-col-12 p-lg-6 " >
      <div class="statistics-container p-col-12">
        <div class="p-grid">
          <div class="statistics-item-container p-col-6" tabindex="0" *ngFor="let item of statistics">
            <h2 role="none">{{item.value}}</h2>
            <span>{{item.label}}</span>
          </div>
        </div>
      </div>
      <div *ngIf="displayCalendar" class="calendar-container p-col-12 p-grid">

            <img src="assets/icons/up.svg" (click)="meetingPreviousPage()"
                [class.hidden-arrow]="pagination.empty"
            alt=""/>

            <div class="calendar-container-grid">
              <div class="calendar-item" *ngFor="let meeting of meetings"
                  (click)="showModalDetailMeeting(meeting.id)">
                <div class="date" >
                  <img src="assets/icons/calendar.svg" alt=""/>
                  {{ getDateFromAPIStr(meeting.beginDate) | date: 'dd/MMM' }}
                </div>
                <div class="place">
                  <img src="assets/icons/pin.svg"
                      *ngIf="meeting?.typeMeetingEnum !== typeMeeting.VIRTUAL" alt=""/>
                  <i class="fas fa-desktop"
                    *ngIf="meeting?.typeMeetingEnum !== typeMeeting.PRESENCIAL"></i>
                  {{ meeting?.name }}
                </div>
              </div>
            </div>

            <img src="assets/icons/down.svg" (click)="meetingNextPage()"
                [class.hidden-arrow]="pagination.empty"
            alt=""/>
          </div>
    </div>
  </div>
  <p-toast position="top-right"></p-toast>

  <p-dialog [(visible)]="modalDetailMeeting" *ngIf="modalDetailMeeting" [modal]="true"
  [style]="{width: '555px'}"
            showEffect="fade" [resizable]="false" [draggable]="false" [responsive]="true"
            class="dialog-detail">

    <div class="row">
      <div class="col-1 float-end align-content-center ">
           <i class="far tiny-icon fa-arrow-alt-circle-left" (click)="previousMeetingDetail()" *ngIf="meetingDetail?.hasPreviousMeeting"></i>
      </div>
      <div class="col-10 meeting">
        <h2 class="title col-12">{{meetingDetail.name}}</h2>
        <h5 class="description col-12">{{labelDescriptionDetailMeeting(meetingDetail)}}</h5>

        <div class="date-time-container mt-3 mb-3 row col-12">

            <div class="date d-flex col-12 col-sm-5">
              <img class="tiny-icon" src="assets/icons/calendar2.svg" alt="calendario">
              <div class="date-text">
              {{getDateFromAPIStr(meetingDetail?.beginDate) | date: 'dd'}}/{{getDateFromAPIStr(meetingDetail?.beginDate) | date: 'MMM'}}
              </div>
            </div>
            <div class="time col-12 col-sm-7">
              <div class="time-text">
              {{getDateFromAPIStr(meetingDetail?.beginDate) | date: 'HH:mm'}}h
              <i class="far fa-clock tiny-icon"></i>{{getDateFromAPIStr(meetingDetail?.endDate) | date: 'HH:mm'}}h
              </div>
            </div>

        </div>
        <div class="locality-channel-container row mb-3">
          <div
            [ngClass]="meetingDetail.typeMeetingEnum === typeMeeting.PRESENCIAL ? 'locality-container' : 'left-container' "
            *ngIf="meetingDetail.typeMeetingEnum !== typeMeeting.VIRTUAL" class="row" >
            <div class="locality col-12">{{meetingDetail?.place}}</div>
            <div class="adreess col-12">{{meetingDetail?.address}}</div>
            <div class="icons-locality col-12 mt-2">
              <img src="assets/icons/gmaps.svg" alt="google-maps" width="40px" height="40px"
              (click)="goToLink('https://maps.google.com/?q=' + meetingDetail.place + '+' + meetingDetail.address)">
              <img src="assets/icons/waze.svg"  class="icon" alt="waze" width="40px" height="40px" class="waze"
                   (click)="goToLink('waze://?q==' + meetingDetail.place + '+' + meetingDetail.address)">
            </div>
          </div>
          <div
            [ngClass]="meetingDetail.typeMeetingEnum === typeMeeting.VIRTUAL ? 'channels-container' : 'right-container' "
            *ngIf="meetingDetail.typeMeetingEnum !== typeMeeting.PRESENCIAL">
            <a *ngFor=" let channel of meetingDetail.channels"
               [ngClass]="channel.url ? 'channel pointer' : 'channel'"
               target="_blank" (click)="goToLink(channel.url)">{{channel.name}}</a>
          </div>
        </div>
      </div>
      <div class="col-1 float-start align-content-center">
        <i class="far tiny-icon fa-arrow-alt-circle-right" (click)="nextMeetingDetail()" *ngIf="meetingDetail?.hasNextMeeting"></i>
      </div>
    </div>
  </p-dialog>
</div>
